<template>
  <transition name="btm-up">
    <div class="snack-bar-overlay d-flex">
      <div class="snack-bar d-flex align-items-center justify-content-between mb-5" :class="type">
        <div class="d-flex align-items-center">
          <span v-if="type == 'success'" class="snack-success d-flex">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75ZM15.1893 7.69455C15.4348 7.45192 15.4372 7.0562 15.1945 6.81068C14.9519 6.56516 14.5562 6.56282 14.3107 6.80545L8.42558 12.6213L6.43933 10.6583C6.19381 10.4157 5.79809 10.418 5.55546 10.6635C5.31283 10.9091 5.31516 11.3048 5.56067 11.5474L7.98624 13.9445C8.2297 14.1852 8.62142 14.1852 8.86489 13.9445L15.1893 7.69455Z" fill="#00A042"/>
            </svg>
          </span>
          <span v-if="type == 'error'" class="snack-error d-flex">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75ZM10.0254 4.5C10.3706 4.5 10.6504 4.77982 10.6504 5.125V11.375C10.6504 11.7202 10.3706 12 10.0254 12C9.68021 12 9.40039 11.7202 9.40039 11.375V5.125C9.40039 4.77982 9.68021 4.5 10.0254 4.5ZM10 13C9.44771 13 9 13.4477 9 14C9 14.5523 9.44771 15 10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13Z" fill="#F44336"/>
            </svg>
          </span>
          <span v-if="type == 'loading'" class="snack-loading d-flex">
            <i class="icon icon-loading"></i>
          </span>
          <p class="snack-bar-message ml-1">{{ message }}</p>
        </div>
        <span class="snack-bar-close d-flex align-items-center justify-content-center" @click="gSnackbarClose">
          <i class="icon icon-small-cancel"></i>
        </span>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "GSnackBar",
  props: {
    message: String,
    type: String
  },
  methods: {
    ...mapActions("common", {
      gSnackbarClose: "gSnackbarClose"
    }),
  }
};
</script>

<style lang="scss" scoped>
.snack-bar-overlay {
  min-width: 220px;

  position: fixed;
  top: 0;
  z-index: 9999999999;
  left: 50%;
  transform: translate(-50%, 0px);
  .snack-bar {
    padding: 7.5px 16px;
    margin: auto;
    margin-top: 68px;
    color: $textLightModeHigh;
    border-radius: $radius;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    width: 352px;
    padding: 16px;

    &-close {
      width: 24px;
      height: 24px;
      font-size: 16px;
      position: relative;
      color: $textLightModeHigh;
      cursor: pointer;
      @include trans-all;
      &::before {
        content: '';
        background: #000;
        position: absolute;
        border-radius: $radius;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
      &:hover:before {
        opacity: 0.1;
      }
    }

    &.success {
      background: $accentGreen100;
    }
    
    &.loading {
      background: $primaryBlue100;
    }
    
    &.error {
      background: $accentRed100;
      color: $accentRed300;
    }

    .snack-loading {
      animation: cog 1s infinite;
      color: $primaryBlue350;
    }
    @keyframes cog {
      100% {
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
}

.btm-up-enter-active,
.btm-up-leave-active {
  transition: opacity 0.8s ease-out;
}
.btm-up-enter,
.btm-up-leave-to {
  opacity: 0;
}
.btm-up-enter-to,
.btm-up-leave {
  opacity: 1;
}
</style>
